import React, { useEffect, useRef } from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const inputCls = 'h-14 text-lg bg-[#0f1724] border-white/15 text-white placeholder:text-white/30 focus:border-[#C6A14A] focus-visible:ring-[#C6A14A]/30';

// Focus the first field when a screen opens and keep it (and Continue below it) above the iPhone keyboard.
export const useAutoFocus = (stepKey) => {
  const ref = useRef(null);
  useEffect(() => {
    const t = setTimeout(() => {
      const el = ref.current;
      if (!el) return;
      el.focus({ preventScroll: true });
      setTimeout(() => el.scrollIntoView({ block: 'center', behavior: 'smooth' }), 250);
    }, 320);
    return () => clearTimeout(t);
  }, [stepKey]);
  return ref;
};

export const keepVisible = (e) => setTimeout(() => e.target.scrollIntoView({ block: 'center', behavior: 'smooth' }), 300);

export const Field = React.forwardRef(({ id, label, required, hint, ...props }, ref) => (
  <div className="space-y-1.5">
    <Label htmlFor={id} className="text-[#E8E4DE]/80 text-sm">
      {label}{required && <span className="text-[#C6A14A]"> *</span>}
    </Label>
    <Input ref={ref} id={id} required={required} aria-required={required || undefined} onFocus={keepVisible}
      className={inputCls} data-testid={`mobile-${id}`} {...props} />
    {hint && <p className="text-xs text-[#E8E4DE]/40">{hint}</p>}
  </div>
));
Field.displayName = 'Field';

export const OptionButton = ({ selected, onClick, children, testId }) => (
  <button type="button" onClick={onClick} data-testid={testId} aria-pressed={selected}
    className={`w-full min-h-[48px] px-4 py-2.5 rounded-xl border text-left transition-colors ${
      selected ? 'border-[#C6A14A] bg-[#C6A14A]/10 text-white' : 'border-white/15 text-[#E8E4DE] hover:border-[#C6A14A]/50'}`}>
    {children}
  </button>
);
